import { type ItemComponentProps } from 'javascripts/dnd/components/types';
import React from 'react';
import type DraggableUiItem from '../dnd/DraggableUiItem';
import styles from './styles.mod.less';

type CardUiItemProps = {
  dragItem: DraggableUiItem;
} & ItemComponentProps;

const CardUiItem: React.FC<CardUiItemProps> = ({ dragItem, dragPreview }) => {
  if (dragPreview) {
    return <aha-card-divider />;
  }

  return (
    <div
      className={styles.fieldPreview}
      data-testid={`UiItem-${dragItem.item.id}`}
    >
      <aha-card-divider />
    </div>
  );
};

export default CardUiItem;
